<template>
    <div class="card card-info-list" id="summary_hotel_view" role="complementary" :aria-label="__('messages.complementary_summary')">
        <div class="card-body">
            <div class="card-header cursor-pointer" data-toggle="collapse" data-target="#collapsabletitle" aria-expanded="true" aria-controls="collapsabletitle">
                <h3 class="title d-flex align-items-center justify-content-between font-14">
                    <span class="font-14  d-flex align-items-center ">
                        <span class="icons-building-hotel mr-1" aria-hidden="true"></span> Hotel 
                    </span>
                    <i aria-hidden="true"  class="icons-chevron-up"></i>
                </h3>
            </div>
            <div class="mt-2 mb-3">
                <h4 class=""> {{ summary.name }}</h4>
                <small class="font-14 d-block">
                    {{ summary.location.city }}, {{ summary.location.country }}
                </small>
                <span :class="`m-0 font-icons ${getStarClass()}`" :alt="'Hotel ' + summary.stars + ' estrellas'"></span>
            </div>
            <div class="collapse show" id="collapsabletitle">
                <div class="">
                    <div class="product-detail-specs">
                        <div class="product-detail-item">
                            <div>
                                <p>{{ __('messages.checkin') }}</p>
                                <p class="product-detail-item-title"> {{ summary.checkIn | date("ddd D MMM YYYY") }} {{
                                    summary.room.checkInTime }}</p>
                            </div>
                        </div>
                        <div class="product-detail-item">
                            <div>
                                <p>{{ __('messages.checkout') }}</p>
                                <p class="product-detail-item-title">{{ summary.checkOut | date("ddd D MMM YYYY") }}
                                    {{ summary.room.checkOutTime }}
                                    ({{ __('messages.midday') }})</p>

                            </div>
                        </div>
                        <div class="product-detail-item">
                            <div>
                                <p>{{ __('messages.Total_length_of_stay') }}</p>
                                <p class="product-detail-item-title">{{ nights }} {{ nights > 1 ? __('messages.nights')
                                    :
                                    __('messages.night') }}</p>
                                <p class="mt-2">{{ __('messages.you_choose') }}</p>
                                <p class="product-detail-item-title">
                                    {{ summary.roomsTotal }} {{ summary.roomsTotal > 1 ? __('messages.rooms') :
                                        __('messages.room') }},
                                    {{ summary.adults }} {{ summary.adults > 1 ? __('messages.adults') :
                                        __('messages.adult') }}
                                    <template v-if="summary.children > 0">, {{ summary.children }} {{ summary.children >
                                        1 ?
                                        __('messages.childrens') : __('messages.children') }}
                                    </template>
                                </p>
                            </div>
                        </div>


                    </div>

                </div>
                <div class="">

                    <button class="btn btn-link btn-block border-0 text-left bg-white p-0 collapse_summary_h"
                        type="button" data-toggle="collapse" data-target="#collapseExample1" aria-expanded="true"
                        aria-controls="collapseExample1" @click="onOpenSummary()">
                        <span class="summary_text_collapse">{{ !open ? __('messages.Show_room_details') :
                            __('messages.hide_room_details') }}</span>
                        <i :class="'icons-chevron-' + (!open ? 'down' : 'up') + ' collapse_summary_icon'"
                            aria-hidden="true"></i>
                    </button>

                    <div :class="{ 'show': open }" class="collapse" id="collapseExample1">
                        <div class="product-detail-item pt-2 pb-0 d-block">
                            <div v-for="rm in listRooms" :key="rm.room.id" class="space-rooms">
                                <span>{{ rm.room.quantity }}x</span>
                                <div>
                                    {{ rm.room.name }}
                                    <small class="text-subtle">{{ __('mealplans.' + rm.rate.mealPlan)
                                        }}</small>
                                    <small v-if="rm.rate.cancellation.isCancellationFree"><span
                                            class="product-detail-item-sucess"> {{
                                                __('messages.free_cancellation_room')
                                            }}</span>

                                        {{ __('messages.reservation_until_room') }}
                                        {{ rm.rate.cancellation.untilDateCancellation |
                                        date(__('formaters.cancel_free')) }}
                                    </small>
                                    <small class="text-muted" v-else>
                                        {{ __('mealplans.AR') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Breakdown from './Breakdown.vue';
const site = window.__pt.settings.site;
import { CookieService } from '../../services/CookieService';
export default {
    props: {
        summary: {},
        customclass: "",
        isMobile: false,
        summaryMobile: false
    },
    data() {
        return {
            open: true,
            headerCollapsed: true,
            siteConfig: site,
            source: "",
            isMetaTotal: site.isMetaTotal,
            currencySite: site.currency,
            listRooms: this.mergeRooms(),
            nights: 0
        }
    },
    mounted() {
        this.getCookieSource();
        this.nights = this.getNights(this.summary.checkIn, this.summary.checkOut);
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';

            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleDateString(__pt.settings.site.culture, { month: 'short' }).replace('.', ''); // Elimina el punto
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        },
        getCookieSource() {
            this.source = CookieService.getCookie("source_origin");

        },
        getSummaryClass() {
            let className = "";
            if (this.summaryMobile) {
                className = "collapseOne";
            }

            return className;
        },
        onOpenSummary() {
            setTimeout(() => {
                this.open = !this.open;
            }, 100);
        },
        toggleHeaderCollapse() {
            if (!this.summaryMobile) {
                this.headerCollapsed = !this.headerCollapsed;
            }
        },
        getStarClass() {
            if (this.summary.stars % 1 == 0) {
                return [`icon-${this.summary.stars}-star`];
            } else {
                return [`icon-${Math.floor(this.summary.stars)}-half-star`];
            }
        },
        mergeRooms() {
            const map = new Map();
            this.summary.ratesWithRooms.forEach((item) => {
                const key = `${item.room.name}${item.room.mealPlan}${item.rate.cancellation.isCancellationFree}`;
                if (map.has(key)) {
                    const existingItem = map.get(key);
                    existingItem.room.quantity += item.room.quantity;
                } else {
                    map.set(key, { ...item, room: { ...item.room, quantity: item.room.quantity } });
                }
            });
            return Array.from(map.values())
        },
        getNights(startDate, endDate) {
            const inicio = new Date(startDate);
            const fin = new Date(endDate);
            const diferenciaMilisegundos = fin - inicio;
            const noches = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
            return noches;
        },
        toggleHeaderCollapse() {
                this.headerCollapsed = !this.headerCollapsed;
                // Esto asegura que el estado visual coincida con el estado del collapse
                const collapseElement = document.getElementById('collapsabletitle');
                if (collapseElement) {
                    if (this.headerCollapsed) {
                        collapseElement.classList.remove('show');
                    } else {
                        collapseElement.classList.add('show');
                    }
                }
            }

    },
    components: {
        Breakdown
    }
}
</script>

<style scoped>
.chevron-animated {
    transition: transform 0.3s ease-in-out;
    transform-origin: center;
}

.chevron-animated.rotated {
    transform: rotate(180deg);
}

.collapse_summary_icon {
    transition: transform 0.3s ease-in-out;
    transform-origin: center;
}
</style>
